export const BUILD_TIME_EPO_EDIT_ENABLED = false;

export const isEpoEditEnabledSeller = (debugPanelEpoEditEnabledSeller: boolean): boolean =>
  BUILD_TIME_EPO_EDIT_ENABLED || debugPanelEpoEditEnabledSeller;
